<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.title" placeholder="商品名称"></el-input>
                </div>
            </div> 
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.checkStatus" clearable placeholder="审核状态">
                        <el-option
                            v-for="item in checkStatuss"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="购买者"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.className" placeholder="班级名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.startDate" style="width:150px;"
                    type="date"
                    placeholder="下单开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker
                    v-model="form.endDate" style="width:150px;"
                    type="date"
                    placeholder="下单结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-radio-group v-model="form.sortType">
                    <el-radio-button label="1">按时间排序</el-radio-button>
                    <el-radio-button label="2">按积分排序</el-radio-button>
                </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <el-button type="primary" @click="common.page = 1;getData()">查询</el-button>
            <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            <el-button type="primary" @click="batchCheckUser">批量审核</el-button>
            <!-- <el-button type="primary" @click="exportExcel">订单商品详情导出</el-button> -->
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="商品图标"  :show-overflow-tooltip="true" width="90px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.iconUrl != null && scope.row.iconUrl != ''">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.iconUrl" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.iconUrl"  lazy="loading" :alt="scope.row.iconUrl" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="商品标题"  :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column prop="content" label="商品详情" :show-overflow-tooltip="true"></el-table-column> -->
                <el-table-column prop="price" label="价格(金币)" width="80px"></el-table-column>
                <el-table-column prop="" label="购买者" :show-overflow-tooltip="true" width="80px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showData(scope.row.createBy)">{{scope.row.name}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="100px"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100px"></el-table-column>
                <el-table-column prop="gmtCreate" label="下单时间" width="100px"></el-table-column>
                <el-table-column prop="" label="审核状态" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkStatus == 0">
                            <span style="color: red;">兑换失败</span>
                        </div>
                        <div v-else-if="scope.row.checkStatus == 1">待审核</div>
                        <div v-else-if="scope.row.checkStatus == 2">
                            <span style="color: green;">兑换成功</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="checkRemark" label="审核留言" :show-overflow-tooltip="true"  width="100px"></el-table-column>
                <el-table-column prop="checkTime" label="审核时间"  width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="124px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color:#387EE8;" v-if="scope.row.checkStatus == 1"
                            @click.native.prevent="checkUser(scope.row.id)"
                            type="text"
                            size="small">
                            审核
                        </el-button>
                        <el-button  @click.native.prevent="showContent(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">查看商品详情</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!--审核 -->
        <div v-if="checkVisible">
            <check ref="check"></check>
        </div>
        <!--用户详情 -->
        <div v-if="userDetailsVisible">
            <userDetails ref="userDetails"></userDetails>
        </div>
        <!--商品详情 -->
        <div v-if="commodityDetailVisible">
            <commodityDetail ref="commodityDetail"></commodityDetail>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import check from './Check.vue';
    import userDetails from './UserDetails.vue';
    import commodityDetail from './CommodityDetail.vue';

    export default {
        name:"CommodityList",
        data(){
            return{
                loading:false,
                loadingText:"",

                menuName:"",
                addVisible:false,
                updateVisible:false,
                checkVisible:false,
                updateContentVisible:false,
                userDetailsVisible:false,
                commodityDetailVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    title:"",
                    name:"",
                    gradeName:"",
                    className:"",
                    checkStatus:'',
                    startDate:'',
                    endDate:'',
                    sortType:1
                },
                data:[],
                depts:[],
                checkStatuss:[{
                    value: '',
                    label: '全部'
                },{
                    value: 0,
                    label: '兑换失败'
                }, {
                    value: 1,
                    label: '待审核'
                },{
                    value: 2,
                    label: '兑换成功'
                }]
            }
        },
        components: {
            check,userDetails,commodityDetail
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.form.sortType = 1; // 默认按时间排序
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";

                let url  = this.commodityOrderListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    title:this.form.title,
                    checkStatus:this.form.checkStatus,
                    userName:this.form.name,
                    gradeName:this.form.gradeName,
                    className:this.form.className,
                    startDate:this.form.startDate == null?'':this.form.startDate,
                    endDate:this.form.endDate == null?'':this.form.endDate,
                    sortType:this.form.sortType
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){ 
                if(row.checkStatus == 1){
                    return true;
                }else{
                    return false;
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            checkUser(id){
                this.checkVisible = true;
                this.$nextTick(() => {
                    this.$refs['check'].init(id);
                })
            },
            batchCheckUser(){
                let checkIdArr=new Array();
                if(this.common.checkboxArr.length != 0){
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                }else{
                    this.$commonFn.showTip("请选择审核数据",2);
                    return;
                }

                this.checkVisible = true;
                this.$nextTick(() => {
                    this.$refs['check'].init(checkIdArr.join(","));
                })
            },
            showData(val){
                let url  = this.getUserUrl;
                let data = {
                   id:val
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 触发详情界面
                        this.userDetailsVisible = true;
                        this.$nextTick(() => {
                            this.$refs['userDetails'].init(res.data);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
                
            },
            showContent(data){
                this.commodityDetailVisible = true;
                this.$nextTick(() => {
                    this.$refs['commodityDetail'].init(data);
                })
            },
            exportExcel(){
                if(this.common.total>50000){
                    this.$commonFn.showTip("导出数据超出5W，目前不支持。请添加查询条件限制当前页面总条数，然后再进行导出",2);
                    return;
                }
                this.exportData();
            },
            exportData(){
                if(this.form.startDate == '' || this.form.startDate == null){
                    this.$commonFn.showTip("下单开始日期不可为空",2);
                    return;
                }
                if(this.form.endDate == '' || this.form.endDate == null){
                    this.$commonFn.showTip("下单结束日期不可为空",2);
                    return;
                }

                let schoolName="";
                for(var i=0;i<this.depts.length;i++){
                    if(this.form.deptId == this.depts[i].id){
                        schoolName = this.depts[i].name;
                        break;
                    }
                }
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.commodityOrderExportExcelUrl;
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('title', this.form.title);
                param.append('checkStatus', this.form.checkStatus);
                param.append('userName', this.form.name);
                param.append('gradeName', this.form.gradeName);
                param.append('className', this.form.className);
                param.append('startDate', this.form.startDate == null?'':this.form.startDate);
                param.append('endDate', this.form.endDate == null?'':this.form.endDate);
                param.append('sortType', this.form.sortType);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    let fileName = fileName=schoolName+'商品订单汇总表('+this.form.startDate+'到'+this.form.endDate+').xls';
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
            },
            exportPageExcel(){

            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/shop/order/CommodityOrder.vue